export enum GraphGradient {
  'blue' = 'watcherr::graph-gradient-blue',
  'orange' = 'watcherr::graph-gradient-orange',
  'red' = 'watcherr::graph-gradient-red',
}

const graphGradients: { [key in GraphGradient]: any } = {
  [GraphGradient.blue]: (
    <linearGradient
      key={GraphGradient.blue}
      id={GraphGradient.blue}
      x1="0"
      x2="0"
      y1="0"
      y2="1"
    >
      <stop offset="0%" stopColor="rgba(33, 98, 239, 0.2)" />
      <stop offset="100%" stopColor="rgba(66, 134, 243, 0)" />
    </linearGradient>
  ),
  [GraphGradient.orange]: (
    <linearGradient
      key={GraphGradient.orange}
      id={GraphGradient.orange}
      x1="0"
      x2="0"
      y1="0"
      y2="1"
    >
      <stop offset="0%" stopColor="rgba(255, 128, 46, 0.2)" />
      <stop offset="100%" stopColor="rgba(254, 168, 45, 0)" />
    </linearGradient>
  ),
  [GraphGradient.red]: (
    <linearGradient
      key={GraphGradient.red}
      id={GraphGradient.red}
      x1="0"
      x2="0"
      y1="0"
      y2="1"
    >
      <stop offset="0%" stopColor="rgba(255, 46, 46, 0.2)" />
      <stop offset="100%" stopColor="rgba(255, 75, 75, 0)" />
    </linearGradient>
  ),
};

export { graphGradients };
